/* esm.sh - rxjs@7.8.2/dist/esm/internal/BehaviorSubject */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/BehaviorSubject.mjs";
